// import stuReport from '@/views/studyReport1/stuReport'
const stuReport = () => import('@/views/studyReport1/stuReport')
// import chapterReport from '@/views/studyReport1/chapterReport'
const chapterReport = () => import('@/views/studyReport1/chapterReport')
export default [
    {
        path: '',
        component: stuReport,
        meta: {
            title: '学情报告'
        }
    },
    {
        path: '/stureport1/:sectionCode/:stuId',
        component: chapterReport,
        meta: {
            title: '学情报告'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/stureport1.js